var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiverHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 150 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "background",
    style: {
      fill: "#0f0",
      stroke: "#0f0",
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "foreground",
    style: {
      fill: "#fff",
      stroke: "#45a",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25,
    y: 25,
    width: 70,
    height: 70,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 0 6.48457 1.30889 6.48457 7.38462C6.48457 10.9796 0 12.3462 0 16.6154C0 22.1394 6.48457 24 6.48457 24H22.2328C22.2328 24 12.0428 21.5769 12.0428 16.6154C12.0428 12.4219 15.6469 9.55168 12.5638 5.30769C9.18044 0.652644 1.91063 0 1.91063 0H0ZM20.3222 0.259615C20.2932 0.266827 20.2643 0.277644 20.2353 0.288462C20.087 0.320913 19.9531 0.400241 19.859 0.519231C19.7179 0.69952 19.5876 0.883413 19.4537 1.06731C19.309 1.04567 19.1642 1.04567 19.0195 1.06731C18.4984 1.12861 18.0461 1.44231 17.8036 1.90385C17.2572 2.87019 16.244 4.41707 15.7193 5.97115C15.466 6.56611 15.6071 7.2512 16.0667 7.70192C14.156 13.4171 14.5324 18.4904 14.5324 18.4904C14.5577 18.8474 14.8689 19.1214 15.2271 19.0962C15.5854 19.0709 15.8604 18.7608 15.8351 18.4038C15.8351 18.4038 15.5094 13.5469 17.3115 8.13462C17.9809 8.07692 18.5382 7.60096 18.701 6.95192C19.0195 6.00721 19.9422 4.51442 20.5538 3.43269C20.8541 2.9351 20.8541 2.3149 20.5538 1.81731C20.6732 1.65505 20.7745 1.48558 20.9011 1.32692C21.0821 1.125 21.1146 0.829327 20.9844 0.591346C20.8577 0.353366 20.5899 0.219952 20.3222 0.259615ZM23.1013 6C22.5259 6 16.9062 9.12981 16.9062 19.7019L18.9326 20.7981C18.9326 8.23558 23.6802 6 23.1013 6ZM23.9118 10.6442C23.4016 10.7272 21.1327 12.6887 20.5248 13.3846C19.6889 15.137 19.8879 18.4327 19.8879 18.4327C21.2775 14.0192 23.9697 10.9688 23.9987 10.7308C24.0059 10.655 23.9842 10.6334 23.9118 10.6442Z",
    fill: "blue"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiverHighlight);
export default __webpack_public_path__ + "static/media/RiverHighlight.7112db6df590f99061c4ad684b2f00a9.svg";
export { ForwardRef as ReactComponent };